import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';

import {AppRoutingModule} from '@/app-routing.module';
import {AppComponent} from './app.component';
import {MainComponent} from '@modules/main/main.component';
import {LoginComponent} from '@modules/login/login.component';
import {HeaderComponent} from '@modules/main/header/header.component';
import {FooterComponent} from '@modules/main/footer/footer.component';
import {MenuSidebarComponent} from '@modules/main/menu-sidebar/menu-sidebar.component';
import {BlankComponent} from '@pages/blank/blank.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ProfileComponent} from '@pages/profile/profile.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RegisterComponent} from '@modules/register/register.component';
import {DashboardComponent} from '@pages/dashboard/dashboard.component';
import {ToastrModule} from 'ngx-toastr';
import {MessagesComponent} from '@modules/main/header/messages/messages.component';
import {NotificationsComponent} from '@modules/main/header/notifications/notifications.component';

import {DatePipe, registerLocaleData} from '@angular/common';
import localeEn from '@angular/common/locales/en';
import {UserComponent} from '@modules/main/header/user/user.component';
import {ForgotPasswordComponent} from '@modules/forgot-password/forgot-password.component';
import {RecoverPasswordComponent} from '@modules/recover-password/recover-password.component';
import {LanguageComponent} from '@modules/main/header/language/language.component';
import {MainMenuComponent} from './pages/main-menu/main-menu.component';
import {SubMenuComponent} from './pages/main-menu/sub-menu/sub-menu.component';
import {MenuItemComponent} from './components/menu-item/menu-item.component';
import {ControlSidebarComponent} from './modules/main/control-sidebar/control-sidebar.component';
import {StoreModule} from '@ngrx/store';
import {authReducer} from './store/auth/reducer';
import {uiReducer} from './store/ui/reducer';
import {ProfabricComponentsModule} from '@profabric/angular-components';
import {defineCustomElements} from '@profabric/web-components/loader';
import {SidebarSearchComponent} from './components/sidebar-search/sidebar-search.component';
import {NgxSpinnerModule} from 'ngx-spinner';
import {ProcessorManagementComponent} from '@components/processor-management/processor-management.component';
import {ActivityCreationComponent} from '@components/activity-creation/activity-creation.component';
import {DailyActivityCreationComponent} from "@components/daily-activity-creation/daily-activity-creation.component";
import { ActivityMappingComponent } from '@components/activity-mapping/activity-mapping.component';
import {ConfigService} from "@/config.service";
import {ConfigLoader} from "@/config.loader";
import {AddActivityComponent} from "@components/add-activity/add-activity.component";
import {FinalQrComponent} from "@components/final-qr/final-qr.component";
import {QrGenerationComponent} from "@components/Qr-generation/qr-generation.component";
import {FinalActivityScreenComponent} from "@components/final-activity-screen/final-activity-screen.component";
import {FinalLabelPrintComponent} from "@components/final-label-print/final-label-print.component";
import { AllzProductDesign } from '@components/allz-product-design/allz-product-design.component';
import { SwiperModule } from "swiper/angular";

defineCustomElements();
registerLocaleData(localeEn, 'en-EN');

@NgModule({
    declarations: [
        AppComponent,
        MainComponent,
        LoginComponent,
        HeaderComponent,
        FooterComponent,
        MenuSidebarComponent,
        BlankComponent,
        ProfileComponent,
        RegisterComponent,
        DashboardComponent,
        MessagesComponent,
        NotificationsComponent,
        UserComponent,
        ForgotPasswordComponent,
        RecoverPasswordComponent,
        LanguageComponent,
        MainMenuComponent,
        SubMenuComponent,
        MenuItemComponent,
        ControlSidebarComponent,
        SidebarSearchComponent,
        ProcessorManagementComponent,
        ActivityMappingComponent,
        ActivityCreationComponent,
        DailyActivityCreationComponent,
        AddActivityComponent,
        FinalQrComponent,
        QrGenerationComponent,
        FinalActivityScreenComponent,
        FinalLabelPrintComponent,
        AllzProductDesign,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        StoreModule.forRoot({auth: authReducer, ui: uiReducer}),
        HttpClientModule,
        AppRoutingModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-top-right',
            preventDuplicates: true
        }),
        ProfabricComponentsModule,
        NgxSpinnerModule,
        SwiperModule
    ],
    providers: [DatePipe,
        {
            provide: APP_INITIALIZER,
            useFactory: ConfigLoader,
            deps: [ConfigService],
            multi: true,
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
